<script>
  import SectionFeature from './SectionFeature.svelte';
  import SectionFeatureResponsive from './SectionFeatureResponsive.svelte';
  import SectionColumns from './SectionColumns.svelte';
  import SectionRates from './SectionRates.svelte';
  import SectionFaqs from './SectionFaqs.svelte';
  export let config = {};
  export let data = {};
  export let i;
</script>

<div class="{i%2 !== 0 ? 'odd' : ''}">
  {#if config.tpl === 'feature'}
  <SectionFeatureResponsive {config} {data} />
  <!-- <SectionFeature {config} {data} /> -->
  {:else if config.tpl === 'columns'}
  <SectionColumns {config} {data} />
  {:else if config.tpl === 'rates'}
  <SectionRates {config} {data} />
  {:else if config.tpl === 'faqs'}
  <SectionFaqs {config} {data} />
  {/if}
</div>

<style>
  .odd {
    background-color: #f9f9f9;
  }
</style>